import * as types from './mutation-types'
import Vue from 'vue'
import { IMissionPlanTemplateState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbMissionPlanTemplate, IAloDbMissionPlanTemplateConstParam } from '@/models/alodb/AloDbMissionPlanTemplate';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IMissionPlanTemplateState> = {
     
    //Gestion des recherches de missions
    [types.MISSIONPLANTEMPLATE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.MissionPlanTemplate.Title').toString()}).toString()
        state.missionPlanTemplateLoading = true
    },
    [types.MISSIONPLANTEMPLATE_SUCCESS]: (state, missionPlanTemplates:Array<AloDbMissionPlanTemplate>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.MissionPlanTemplate.Title').toString()}).toString()
        state.missionPlanTemplates = missionPlanTemplates          
        state.missionPlanTemplateLoading = false      
    },
    [types.MISSIONPLANTEMPLATE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.MissionPlanTemplate.Title').toString()}).toString()
        state.missionPlanTemplates = []
        state.missionPlanTemplateLoading = false
    },
    [types.MISSIONPLANTEMPLATE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.MissionPlanTemplate.Title').toString()} ${itemId}`}).toString()
        state.missionPlanTemplateLoading = true
    },
    [types.MISSIONPLANTEMPLATE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.MissionPlanTemplate.Title').toString()}).toString()
        state.missionPlanTemplateLoading = false
    },
    [types.MISSIONPLANTEMPLATE_SELECT_DETAIL_SUCCESS]: (state,missionPlanTemplate:AloDbMissionPlanTemplate) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.MissionPlanTemplate.Title').toString()} ${missionPlanTemplate.MPT_ID}`}).toString()
        //1, on met à jour de m'missionPlanTemplate dans la liste des missionPlanTemplates
        const index = state.missionPlanTemplates.findIndex(m => m.MPT_ID == missionPlanTemplate.MPT_ID)
        state.missionPlanTemplates.splice(index == -1 ? state.missionPlanTemplates.length : index, index == -1 ? 0 : 1, missionPlanTemplate)
        state.missionPlanTemplateLoading = false
    },
    [types.MISSIONPLANTEMPLATE_SELECT_DETAIL]: (state,missionPlanTemplate:AloDbMissionPlanTemplate) => {                
        state.originalAdmMissionPlanTemplate = missionPlanTemplate
        state.modifiedAdmMissionPlanTemplate = new AloDbMissionPlanTemplate(missionPlanTemplate as IAloDbMissionPlanTemplateConstParam)
    },
    [types.MISSIONPLANTEMPLATE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.MissionPlanTemplate.Title').toString()} ${libelle}`}).toString()
        state.missionPlanTemplateLoading = true
    },
    [types.MISSIONPLANTEMPLATE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.MissionPlanTemplate.Title').toString()}).toString()
        state.missionPlanTemplateLoading = false
    },
    [types.MISSIONPLANTEMPLATE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmMissionPlanTemplate = {...state.modifiedAdmMissionPlanTemplate,...newProperties}
    },
    [types.MISSIONPLANTEMPLATE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    },
    [types.MISSIONPLANTEMPLATE_DELETE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.DeleteItem',{item:`${i18n.t('Admin.MissionPlanTemplate.Title').toString()} ${libelle}`}).toString()
        state.missionPlanTemplateLoading = true
    },
    [types.MISSIONPLANTEMPLATE_DELETE_SUCCESS]: (state,mptId:number) => {
        state.status = i18n.t('Admin.DeleteItemOk',{item:`${i18n.t('Admin.MissionPlanTemplate.Title').toString()} ${mptId}`}).toString()        
        const index = state.missionPlanTemplates.findIndex(u => u.MPT_ID == mptId)
        state.missionPlanTemplates.splice(index == -1 ? state.missionPlanTemplates.length : index, index == -1 ? 0 : 1)
        state.missionPlanTemplateLoading = false
    },
    [types.MISSIONPLANTEMPLATE_DELETE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorDelete',{item:i18n.t('Admin.MissionPlanTemplate.Title').toString()}).toString()
        state.missionPlanTemplateLoading = false
    }
}


export default mutations
